import light from './lightUrls'
import h5 from './h5Urls'

const urls = {
  light,
  h5,
}

export default urls
